import React from 'react';

export const pageMeta = {
  "name": "DOM Node Lists",
  "link": "/javascript/dom/node-lists"
};

export default function JavascriptDomNodeLists() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">DOM Node Lists</h2>
      <p>Route: /javascript/dom/node-lists</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
